module.exports = __webpack_public_path__ + "static/media/agoda.d79c3f25.ico";